/** @format */

import { LocalField, LocalFunctionProps } from '../../views/Block/Locale/LocalProps';
import i18n from 'i18next';

const _ = require('underscore');

export default class OperationOnService {
    protected props: LocalFunctionProps;

    constructor(props: LocalFunctionProps) {
        this.props = props;
    }

    getRequestParams = (): Array<LocalField> => {
        const obj: Array<LocalField> = [];
        let is3500 = false;
        const jsonParams = JSON.parse(this.props.mvnoBlockRequest.params);
        _.map(jsonParams, (val: string | number, key: string) => {
            if (val) {
                if (key === 'componentName' && val === '3500') {
                    is3500 = true;
                }
                if (key === 'amount') {
                    return;
                }
                if (key === 'status') {
                    key = 'prov:vb.action';
                    if (val === '1' || val === 1) {
                        val = 'prov:vb.activation';
                    }
                    if (val === '2' || val === 2) {
                        val = 'prov:vb.modify';
                    }
                    if (val === '0' || val === 0) {
                        val = 'prov:vb.deactivation';
                    }
                    const trans = i18n.t(val + '');
                    if (trans) {
                        val = trans;
                    }
                } else {
                    key = 'prov:vb.' + key;
                }

                obj.push({ key: key, value: val });
            }
        });
        return obj;
    };
}
